import type {IAdBannerSettings} from 'OK/ads/banner/hook/IBannerJson';

import {IRbAdBannerFeedListAttrs} from './RbAdBannerFeedListAttrs';

export class RbAdBannerFeedListStore {
    public readonly settings: IAdBannerSettings;

    constructor(attrs: IRbAdBannerFeedListAttrs) {
        this.settings = attrs.settings;
    }
}
